import React from 'react';
import jwt_decode from 'jwt-decode';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import plusimg from "../../images/common/plus.png"
import exportimg from "../../images/common/xlsx.png"
import editimg from "../../images/common/pencil.png"
import onimg from "../../images/admin/on-button.png"
import offimg from "../../images/admin/off-button.png"
import history from "../history";
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css'; 
import { exportToExcel } from '../../utils/exportMethods'; 
import '../../css/Buttons.css';
import {config} from '../../constants';
import CircleSign from '../ui/CircleSign';
import ConfirmationModal from '../ui/ConfirmationModal';
import ConfirmDialog from './pages/customComponents/ConfirmDialog';
import Maximize from '../ui/Maximize';
import Minimize from '../ui/Minimize';
import CustomDataGrid from './pages/customComponents/CustomDataGrid';
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';

const url = config.url.URL; //"http://localhost:52344";

const dataSource = createStore({
  key: "buyingAgencyNetworkId",
  loadUrl: `${url}/AgencyNetworkMicroservice`,
  insertUrl: `${url}/InsertOrder`,
  updateUrl: `${url}/UpdateOrder`,
  deleteUrl: `${url}/AgencyNetworkMicroservice`,
  onBeforeSend: (method, ajaxOptions) => {
     ajaxOptions.headers = {  
     'accept': 'application/json',
     'Authorization': 'Bearer '+localStorage.getItem('token')
  }  
   },
   onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});

const appName = "";//ArchicubedWeb; //Production
const LoadSubmenu = (section) =>{
  history.push(appName+'/admin' + (section != '' ? '/'+section : '')) ;
}

const exportAgencyNetwork = (apiData) => {
  const headers = [
    { header: 'Agency Network', key: 'name', autoFit: true },
    { header: 'Status', key: 'isEnabled', autoFit: true }
  ];
  apiData.forEach(obj => {
    delete obj.buyingAgencyNetworkId;
  });

  exportToExcel(headers, apiData, 'agency_network_extract', 'Agency Network Extract');
};

class AgencyNetwork extends React.Component {
    constructor(props) {
        super(props);
        this.applyFilterTypes = [{
          key: 'auto',
          name: 'Immediately'
        }, {
          key: 'onClick',
          name: 'On Button Click'
        }];
        this.state = {
          showFilterRow: true,
          showHeaderFilter: false,
          currentFilter: this.applyFilterTypes[0].key,
          showColumnLines: false,
          showRowLines: true,
          showBorders: true,
          rowAlternationEnabled: true,
          showModal : false,
          showEditModal: false,
          showConfirmationModal: false,
          selectedRowIndex: "",
          showAgencyMenu: true,
          showAgencyNetworkMenu: true,
          fullscreen:false,
          oldCheckValue: false,

          validation: true,
          duplicatedValidation:true,
          selectedRowName:'',
        };
        this.dataGrid = null;
        this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
        this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
        this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
        this.confDiag = React.createRef();
        this.buyingAgencyNetworkIsEnabled = React.createRef();
      }

      fullscreenHandler=()=>{
        this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
      }

      selectedChanged(e) {
        this.setState({
          selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0])
        });
      }
   
      handleClose = () =>{
        this.setState({ showConfirmationModal: true });
      }
  
      closeConfirmationModal = ()=>{
        this.setState({ showConfirmationModal: false });
      }
  
      doubleCloseModals=()=>{
        this.setState({showModal: false, showEditModal: false, showConfirmationModal:false , validation: true, duplicatedValidation:true});
      }

      // to refresh our datagrid table and close all modals
      useRefresh = ()=>{
        this.dataGrid.useRefresh();
        this.setState({
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
        });
      }
  
      handleEditClose = () =>{
          this.setState({ showConfirmationModal: true });
      }
  

  openModal = () => {   
     this.setState({showModal:true ,duplicatedValidation: true ,
      validation:true});
    }

    
  openEditModal = (e) => {
    this.setState({showEditModal:true, selectedRowName: e.row.data.name.trim(), duplicatedValidation: true, validation:true}); 

    this.setState({selectedRowIndex: e.row.data.buyingAgencyNetworkId});
    this.buyingAgencyNetworkIsEnabled.current.checked = e.row.data.isEnabled;
    this.refs.Name_Edit.value = e.row.data.name;
    this.setState({oldCheckValue: e.row.data.isEnabled});
  }

  onExportToExcel = () => {
    apiClient.get(`${url}/AgencyNetworkMicroservice`)
    .then(response => {
        const data = response.data;
        if (data) {
          exportAgencyNetwork(data);
          toast.success('Agency Networks Excel export file has been generated');
        }
      });
  }

  onCreateAgencyNetwork = () => {
    let name = this.refs.Name.value.trim();
    this.setState({ duplicatedValidation: true })

    if (name != "") {
      this.setState({ validation: true })
      let agencyInfo = {
        Name: name
        , IsEnabled: true
      };
      apiClient.post(`${url}/AgencyNetworkMicroservice`, agencyInfo)
        .then(response => {
          const data = response.data;
          if (data) {
            if (data.statusCode == 400) {
              this.setState({ duplicatedValidation: false })
              return;
            } else {
              toast.success('Agency Network has been created');
              this.doubleCloseModals();
              this.useRefresh();
            }
          }
        });
    } else {
      this.setState({ validation: false })
      return;
    }
  }


  onEditAgencyNetwork = () => {
    debugger
    let name = this.refs.Name_Edit.value.trim();

    this.setState({ duplicatedValidation: true })

    if (name != "") {
      this.setState({ validation: true })

      let agencyInfo = {
        Name: name,
        buyingAgencyNetworkId: this.state.selectedRowIndex
      };

      apiClient.put(`${url}/AgencyNetworkMicroservice`, agencyInfo)
        .then(response => {
          const data = response.data;
          if (data) {
            if (data.statusCode == 400) {
              this.setState({ duplicatedValidation: false })
              return;
            } else {

              if (this.state.oldCheckValue != this.buyingAgencyNetworkIsEnabled.current.checked) {
                this.confDiag.current.state.status = this.buyingAgencyNetworkIsEnabled.current.checked;
                this.confDiag.current.state.inEditMode = true;
                this.confDiag.current.state.key = this.state.selectedRowIndex;
                this.confDiag.current.handleOpenConfirmDialog();
              } else {
                this.showEditSuccessToast();
                this.useRefresh();
              }
            }
          }
        });
    } else {
      this.setState({ validation: false })
      return;
    }
  }

  showEditSuccessToast = () => {
    toast.success('Agency Network has been updated');
  }

  showDisabledEnabledToast = (value) => {
    if(!this.confDiag.current.state.inEditMode) {
      if(!value) {
        toast.success('Agency Network has been enabled');
      }
      else {
        toast.success('Agency Network has been disabled');
      }
    }
    else {
      if(value) {
        toast.success('Agency Network has been enabled');
      }
      else {
        toast.success('Agency Network has been disabled');
      }
    }
  }


  componentDidMount(){
    
    const decoded = jwt_decode(localStorage.getItem('token'));
        this.setState({
          showAgencyMenu: decoded.can_manage_agency === "true",
          showAgencyNetworkMenu: decoded.can_manage_agency_network === "true",
          can_export_to_excel: decoded.can_export_to_excel === "true"
        });   
  }

  
  Checkisenabled = (e) =>{
    return e.row.data.isEnabled ;
  }
  Checkisdisabled = (e) =>{
  return !e.row.data.isEnabled ;
  }

  onDelete = (e) => {
    this.confDiag.current.state.key = e.row.data.buyingAgencyNetworkId;
    this.confDiag.current.state.status = e.row.data.isEnabled;
    this.confDiag.current.state.inEditMode = false;
    this.confDiag.current.handleOpenConfirmDialog();
  }

  render() {

    const columns = [
      { dataField: "isEnabled", caption: "Status", width: "110" },
      { dataField: "name", caption: "Agency Network Name", width: "100%" },
      // Add other columns specific to Profiles component
    ];

    const buttonColumn = [
      {text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal},
      {text: "btn_enabled", icon: onimg, hint: "Disable", visible: this.Checkisenabled, name: "delete", onClick: this.onDelete},
      {text: "btn_disabled", icon: offimg, hint: "Enable", visible: this.Checkisdisabled, name: "delete", onClick: this.onDelete},
      // Additional buttons for Profiles component
    ];

    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
        <div className="div-section-title">
          <span>
           {'Agencies > Agency Networks Management'}
          </span>
        </div>
        <div className="div-section-actions push">
          <button  className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden" }  onClick={this.onExportToExcel}>
              <img className="img-section-header" src={exportimg} />
              <label>Export To Excel</label></button>
          <button  className="btn-section-header"  onClick={this.openModal}>
              <img className="img-section-header" src={plusimg} />
              <label>New Agency Network</label>
          </button>
        </div>
        </div>
        <div className="div-body-section-details-body">
        <div className="div-body-submenu">
          <div className={this.state.showAgencyMenu ? "div-submenu-link" : "div-submenu-link hidden"} onClick={() => LoadSubmenu('agencies')} >              
             <div class="div-submenu-label">
                    <label>Agencies</label>
                </div> 
            </div>
            <div className={this.state.showAgencyNetworkMenu ? "div-submenu-link active" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('agencynetworks')} >              
             <div class="div-submenu-label">
                    <label>Agency Networks</label>
                </div> 
            </div>        
          </div>
        <div  className="div-padding-20 div-grid-result">

            <CustomDataGrid
              dataSource={dataSource}
              keyExpr="agencyNetworkId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              onSelectionChanged={this.selectionChanged}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumn={buttonColumn}
            />
      </div>
      </div>

      <Modal show={this.state.showModal} onHide={this.handleClose} size="md" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >New Agency Network</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>  
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Agency Network already exists, your updates cannot be saved.</p></Row>  } 
        {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Agency Network form is not allowed</p></Row>  }
          <Row>
            
       <Form.Group className="mb-3 col-md-12" controlId="Name">
        <Form.Label className={`${this.state.validation ? "normal-title" : "validation-title"}`}>Name <CircleSign/></Form.Label>
        <Form.Control className={`${!this.state.validation && "validation-control"}`} type="text" ref="Name" placeholder="Name" />
         {!this.state.validation && <p className="p-required">Required</p>}
         </Form.Group>
         </Row>     
          
      </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onCreateAgencyNetwork}>
          Create Agency Network
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <Modal show={this.state.showEditModal} onHide={this.handleEditClose} size="md" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >Edit Agency Network</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>  
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Agency Network already exists, your updates cannot be saved.</p></Row>  } 
        {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Agency Network form is not allowed</p></Row>  }
        <Row>
            
        <Form.Group className="mb-3 col-md-12" controlId="Name">
        <Form.Label className={`${this.state.validation ? "normal-title" : "validation-title"}`}>Name <CircleSign/></Form.Label>
        <Form.Control className={`${!this.state.validation && "validation-control"}`} type="text" ref="Name_Edit" placeholder="Name" />
        {!this.state.validation && <p className="p-required">Required</p>}
        <br/>
        <Form.Check type="checkbox" label="Is Enabled" ref={this.buyingAgencyNetworkIsEnabled}/>
      </Form.Group>

      </Row>     
      </Modal.Body>

        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onEditAgencyNetwork}>
            Update Agency Network
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleEditClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"/>

      <ConfirmDialog ref={this.confDiag} microserviceName="AgencyNetworkMicroservice" editfunction={this.showDisabledEnabledToast} refreshfunction={this.useRefresh} title="Can't disable Agency Network" msg="You can’t disable this Agency Network because it is still linked to enabled Agencies. Please disable Agencies first."></ConfirmDialog>
      <ToastContainer position="bottom-right"/>  
      </div>
    );
  }
      onShowFilterRowChanged(e) {
        this.setState({
          showFilterRow: e.value
        });
        this.clearFilter();
      }
      onShowHeaderFilterChanged(e) {
        this.setState({
          showHeaderFilter: e.value
        });
        this.clearFilter();
      }
      onCurrentFilterChanged(e) {
        this.setState({
          currentFilter: e.value
        });
      }
      clearFilter() {
        this.dataGrid.clearFilter();
      }
    }

export default AgencyNetwork;
